'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./BibBoard.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BibBoard = function (_React$Component) {
  (0, _inherits3.default)(BibBoard, _React$Component);

  function BibBoard(props) {
    (0, _classCallCheck3.default)(this, BibBoard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BibBoard.__proto__ || (0, _getPrototypeOf2.default)(BibBoard)).call(this, props));

    _this.state = {
      loaded: false
    };
    return _this;
  }

  (0, _createClass3.default)(BibBoard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.loadImage();
    }
  }, {
    key: 'loadImage',
    value: function loadImage() {
      var _this2 = this;

      var image = new Image();
      image.onload = function () {
        if (_this2.mounted) {
          _this2.setState({ loaded: true });
        }
      };
      image.src = this.props.imageUrl;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bib = _props.bib,
          firstName = _props.firstName,
          title = _props.title,
          imageUrl = _props.imageUrl,
          thumbnailUrl = _props.thumbnailUrl,
          _props$fontColor = _props.fontColor,
          fontColor = _props$fontColor === undefined ? '#0070d9' : _props$fontColor;
      var loaded = this.state.loaded;

      var backgroundStyle = {
        backgroundImage: loaded ? imageUrl && 'url(' + imageUrl + ')' : thumbnailUrl && 'url(' + thumbnailUrl + ')'
      };
      var fontStyle = {
        color: fontColor
      };
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('bib-board', { media: !loaded && thumbnailUrl }), style: backgroundStyle },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('bib-board__title', { 'bib-board_background-color': !imageUrl }) },
          !imageUrl ? _react2.default.createElement(
            'span',
            null,
            title
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'bib-board__content', style: fontStyle },
          _react2.default.createElement(
            'p',
            { className: 'bib-board__content-number' },
            bib
          ),
          _react2.default.createElement(
            'p',
            { className: 'bib-board__content-name' },
            firstName
          )
        ),
        _react2.default.createElement('div', { className: (0, _classnames2.default)('bib-board__footer', { 'bib-board_background-color': !imageUrl }) })
      );
    }
  }]);
  return BibBoard;
}(_react2.default.Component);

exports.default = BibBoard;